<div class="home-section">
  <section class="take-charge sec-height">
    <div class="left">
      <div class="line-text-group health-line">Take charge of your health</div>
      <h1 class="">Natural Herbal Remedy Gives You
        Control</h1>
      <p class="">High Constipation? High Blood Sugar? Not an issue! Use our Tummy Detox &amp;
        Gluco Control POWDER for immediate relief.</p>
      <app-buy-now-button></app-buy-now-button>
      <div class="marketplace-banner">
        <div class="marketplace-content">
          <a href="https://www.amazon.in/stores/HerbsLYF/page/57A0A5E6-AC5B-4F3C-A722-49C0AC2C2E10" target="_blank" rel="noopener" class="marketplace-item">
            <img src="assets/images/amazon-logo.webp" alt="Amazon" class="marketplace-logo">
            <span>Available on Amazon</span>
          </a>
          <div class="divider"></div>
          <a href="https://www.flipkart.com/herbs-lyf-tummy-detox-sugar-free-natural-relief-constipation-powder/p/itmd188d0fe2a013" target="_blank" rel="noopener" class="marketplace-item">
            <img src="assets/images/flipkart-logo.png" alt="Flipkart" class="marketplace-logo">
            <span>Available on Flipkart</span>
          </a>
        </div>
      </div>

    </div>
    <div class="right">
      <img src="assets/images/banner-01.png" alt="banner-01.png">
    </div>
  </section>

  <section class="tummy-detox sec-height">
    <div class="left">
      <img class="img_rotate_bg" src="assets/images/shape2-03.png" alt="shape2-03.png">
      <img class="tummy-detox-img" src="assets/images/img1-1-01.png" alt="img1-1-01.png">
    </div>
    <div class="right">
      <div class="line-text-group tummy-detox-line">
        Tummy Detox
      </div>
      <h2 class="">A herbal product for Constipation
        Relief with following benefits:
      </h2>
      <div class="">
        <ul class="">
          <li class="">Relief from bloating and gas</li>
          <li class="">Improves digestion and gut health</li>
          <li class="">Constipation relief</li>
          <li class="">Smoothens stool</li>
        </ul>
      </div>
      <app-buy-now-button></app-buy-now-button>
      <p class="line-text-group tummy-ingredients-line">
        Tummy Detox Ingredients Unveiled </p>
      <div class="ingredients-grid">
        <div class="ingredient" *ngFor="let ingredient of tummyDetoxIngredients">
          <div class="ingredient-image">
            <img [src]="ingredient.image" [alt]="ingredient.name">
          </div>
          <span class="ingredient-name">{{ingredient.name}}</span>
        </div>
      </div>
    </div>
  </section>

  <app-benefits></app-benefits>

  <section class="herbal-for-life">
    <div class="herbal-content">
      <h2>Herbal For Life</h2>
      <div class="bars">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
      <p>Your journey to a healthy, active life starts here</p>
      <div class="play-btn">
        <a href="https://www.youtube.com/@HerbsLYFHealthcare" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
        </a>
      </div>
    </div>
  </section>

  <section class="tummy-detox madhu-detox sec-height">
    <div class="left">
      <img class="img_rotate_bg" src="assets/images/shape2-03.png" alt="shape2-03.png">
      <img class="tummy-detox-img" src="assets/images/img1-1-02.png" alt="img1-1-01.png">
    </div>
    <div class="right">
      <div class="line-text-group tummy-detox-line">
        Gluco Control
      </div>
      <h2 class="">A herbal product for blood glucose control with following benefits:
      </h2>
      <div class="">
        <ul class="">
          <li class="">Naturally manages Blood sugar level</li>
          <li class="">Improves carbohydrate metabolism</li>
          <li class="">Maintains healthy blood glucose level</li>
          <li class="">Eliminates toxins from body</li>
        </ul>
      </div>
      <app-buy-now-button></app-buy-now-button>
      <p class="line-text-group tummy-ingredients-line">
        Gluco Control Ingredients Unveiled </p>
      <div class="ingredients-grid">
        <div class="ingredient" *ngFor="let ingredient of madhuDetoxIngredients">
          <div class="ingredient-image">
            <img [src]="ingredient.image" [alt]="ingredient.name">
          </div>
          <span class="ingredient-name">{{ingredient.name}}</span>
        </div>
      </div>
    </div>
  </section>
  <app-gallery></app-gallery>
</div>